export default __webpack_public_path__ + "static/media/chat1.a4395e39.jpg";